/* ============================================
   QUOTE WORKSTATION — Variant & Config Pickers
   Asset: workstation-picker.js
   Variant pill/dropdown pickers, inline config pickers, and auto-configure logic
   ============================================ */
(function() {
  'use strict';
  var Q = window.QWS;
  if (!Q) return;
  var state = Q.state;
  var dom = Q.dom;
  var escHtml = Q.escHtml;
  var escAttr = Q.escAttr;
  var fmt = Q.fmt;
  var autoPoints = Q.autoPoints;

  function buildVariantPicker(product, pidx, preSelected, prefResolved) {
    var variants = product.variants || [];
    var options = Q.normalizeOptions(product.options || []);
    preSelected = preSelected || {};
    prefResolved = prefResolved || {};

    // Pre-fetch full variant data (with cost) in the background so it's ready when user picks
    var enrichedVariants = null;
    if (product.handle) {
      Q.fetchProductVariants(product).then(function(fp) {
        if (fp && fp.variants) {
          enrichedVariants = fp.variants;
          if (fp.uom) product.uom = fp.uom;
        }
      });
    }

    var picker = document.createElement('div');
    picker.className = 'rq-ws-variant-picker';

    var selectedOptions = {};
    var optionNames = options.map(function(o) { return o.name; });
    var html = '';

    // Copy pre-selected options
    for (var k in preSelected) {
      selectedOptions[k] = preSelected[k];
    }

    // Option groups — use dropdown for 8+ values, pills for fewer
    options.forEach(function(opt, oi) {
      var values = opt.values || [];
      var isPreResolved = prefResolved[oi];
      html += '<div class="rq-ws-variant-picker__group" data-option-idx="' + oi + '">';
      html += '<div class="rq-ws-variant-picker__group-label">' + escHtml(opt.name);
      if (isPreResolved) html += ' <span style="font-size:11px;opacity:0.6;font-weight:400">(auto)</span>';
      html += '</div>';

      // Check if any values have swatches (theme settings map or Shopify API swatches)
      var swatchMap = window.__wsSwatchUrls || {};
      var swatchColors = window.__wsSwatchColors || {};
      var apiSwatches = opt.swatches || {};
      var hasSwatch = values.some(function(val) { return !!swatchMap[val] || !!swatchColors[val] || !!apiSwatches[val]; });

      if (hasSwatch) {
        // Swatch circles — always use pills for swatches regardless of count
        html += '<div class="rq-ws-variant-picker__pills rq-ws-variant-picker__pills--swatches">';
        values.forEach(function(val) {
          var selected = preSelected[oi] === val ? ' rq-ws-variant-picker__pill--selected' : '';
          var swUrl = swatchMap[val], swColor = swatchColors[val], shopSw = apiSwatches[val];
          if (swUrl) {
            html += '<button class="rq-ws-variant-picker__pill rq-ws-variant-picker__pill--swatch' + selected + '" data-option-idx="' + oi + '" data-value="' + escAttr(val) + '" type="button" data-label="' + escAttr(val) + '"><img class="rq-ws-variant-picker__swatch-img" src="' + escAttr(swUrl) + '" alt="' + escAttr(val) + '"></button>';
          } else if (swColor) {
            html += '<button class="rq-ws-variant-picker__pill rq-ws-variant-picker__pill--swatch' + selected + '" data-option-idx="' + oi + '" data-value="' + escAttr(val) + '" type="button" data-label="' + escAttr(val) + '" style="background:' + escAttr(swColor) + ';width:32px;height:32px;border-radius:50%;padding:0;border:2px solid var(--rq-border-light);"></button>';
          } else if (shopSw && shopSw.color) {
            html += '<button class="rq-ws-variant-picker__pill rq-ws-variant-picker__pill--swatch' + selected + '" data-option-idx="' + oi + '" data-value="' + escAttr(val) + '" type="button" data-label="' + escAttr(val) + '" style="background:' + escAttr(shopSw.color) + ';width:32px;height:32px;border-radius:50%;padding:0;border:2px solid var(--rq-border-light);"></button>';
          } else if (shopSw && shopSw.image) {
            html += '<button class="rq-ws-variant-picker__pill rq-ws-variant-picker__pill--swatch' + selected + '" data-option-idx="' + oi + '" data-value="' + escAttr(val) + '" type="button" data-label="' + escAttr(val) + '"><img class="rq-ws-variant-picker__swatch-img" src="' + escAttr(shopSw.image) + '" alt="' + escAttr(val) + '"></button>';
          } else {
            html += '<button class="rq-ws-variant-picker__pill' + selected + '" data-option-idx="' + oi + '" data-value="' + escAttr(val) + '" type="button">' + escHtml(val) + '</button>';
          }
        });
        html += '</div>';
      } else if (values.length > 8) {
        // Compact dropdown for long lists without swatches
        html += '<select class="rq-ws-variant-picker__select" data-option-idx="' + oi + '">';
        html += '<option value="">Select ' + escHtml(opt.name) + '...</option>';
        values.forEach(function(val) {
          var sel = preSelected[oi] === val ? ' selected' : '';
          html += '<option value="' + escAttr(val) + '"' + sel + '>' + escHtml(val) + '</option>';
        });
        html += '</select>';
      } else {
        // Text pills for short lists
        html += '<div class="rq-ws-variant-picker__pills">';
        values.forEach(function(val) {
          var selected = preSelected[oi] === val ? ' rq-ws-variant-picker__pill--selected' : '';
          html += '<button class="rq-ws-variant-picker__pill' + selected + '" data-option-idx="' + oi + '" data-value="' + escAttr(val) + '" type="button">' + escHtml(val) + '</button>';
        });
        html += '</div>';
      }
      html += '</div>';
    });

    // Result area (no Add button — auto-adds when variant resolves)
    html += '<div class="rq-ws-variant-picker__result">';
    html += '<div class="rq-ws-variant-picker__result-info">Select all options</div>';
    html += '<span class="rq-ws-variant-picker__result-price"></span>';
    html += '</div>';

    picker.innerHTML = html;

    // Track which options the user manually changed (override pref)
    var manualSelections = {};
    var pickerAddDone = false;

    // Add the resolved variant to the quote
    function doPickerAdd(v) {
      if (pickerAddDone) return;
      pickerAddDone = true;

      // Use enriched variant (with cost) if available from background fetch
      if (enrichedVariants) {
        var enriched = enrichedVariants.find(function(ev) { return ev.id === v.id; });
        if (enriched) v = enriched;
      }

      // Save all selections as vendor preferences
      options.forEach(function(opt, oi) {
        if (selectedOptions[oi]) Q.savePref(product.vendor, opt.name, opt.values, selectedOptions[oi]);
      });
      var allResolved = {};
      options.forEach(function(opt, oi) { allResolved[oi] = true; });
      var subDescs = Q.buildPrefSubDescs(options, allResolved, selectedOptions);
      subDescs = Q.defaultSubDescs(subDescs, product);
      var title = Q.quoteTitle(product);
      var em = Q.extractModel(title, v.sku);
      var cost = parseFloat(v.cost) || parseFloat(product.firstCost) || 0;
      var mapPrice = parseFloat(v.price) || 0;
      var itemData = {
        type: 'product',
        variantId: v.id,
        vendor: product.vendor || '',
        title: em.title,
        sku: em.sku,
        quantity: 1,
        msrp: parseFloat(v.compareAtPrice) || Q.findCompareAtPrice(product.variants || [], product),
        cost: cost,
        mapPrice: mapPrice,
        subDescriptions: subDescs,
        productHandle: product.handle
      };
      // Auto-calculate points if we have cost and MAP
      if (cost > 0 && mapPrice > 0) {
        itemData.points = autoPoints(cost, mapPrice);
        itemData.directPrice = mapPrice;
      }
      Q.addItem(itemData);
      dom.searchInput.value = '';
      Q.closeSearch();
      autoConfigureByPreferences();
    }

    // Check if pre-selections already resolve everything
    // autoAdd=true means user interacted — add immediately on match
    function checkResolution(autoAdd) {
      if (Object.keys(selectedOptions).length === optionNames.length) {
        var matched = findMatchingVariant(variants, optionNames, selectedOptions);
        var resultEl = picker.querySelector('.rq-ws-variant-picker__result');
        var infoEl = resultEl.querySelector('.rq-ws-variant-picker__result-info');
        var priceEl = resultEl.querySelector('.rq-ws-variant-picker__result-price');

        if (matched) {
          if (autoAdd) { doPickerAdd(matched); return; }
          resultEl.classList.add('rq-ws-variant-picker__result--visible');
          infoEl.textContent = matched.title || 'Selected variant';
          priceEl.textContent = fmt(parseFloat(matched.price));
        } else {
          // Variant not found in catalog data — try fetching fresh from API
          infoEl.textContent = 'Loading variant...';
          resultEl.classList.add('rq-ws-variant-picker__result--visible');
          Q.fetchProductVariants(product).then(function(fullProduct) {
            if (!fullProduct) {
              infoEl.textContent = 'Variant not available';
              return;
            }
            variants = fullProduct.variants || [];
            product.variants = variants;
            if (fullProduct.uom) product.uom = fullProduct.uom;
            var retryMatch = findMatchingVariant(variants, optionNames, selectedOptions);
            if (retryMatch) {
              if (autoAdd) { doPickerAdd(retryMatch); return; }
              infoEl.textContent = retryMatch.title || 'Selected variant';
              priceEl.textContent = fmt(parseFloat(retryMatch.price));
            } else {
              infoEl.textContent = 'Variant not available';
            }
          });
        }
      }
    }

    // If pre-selections resolve all options, show result (don't auto-add)
    checkResolution(false);
    updatePickerAvailability(picker, variants, optionNames, selectedOptions);

    // Pill click handlers
    var pills = picker.querySelectorAll('.rq-ws-variant-picker__pill');
    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        var oi = parseInt(this.getAttribute('data-option-idx'));
        var val = this.getAttribute('data-value');

        var siblings = picker.querySelectorAll('[data-option-idx="' + oi + '"].rq-ws-variant-picker__pill');
        siblings.forEach(function(s) { s.classList.remove('rq-ws-variant-picker__pill--selected'); });
        this.classList.add('rq-ws-variant-picker__pill--selected');
        selectedOptions[oi] = val;
        manualSelections[oi] = true;

        checkResolution(true);
        updatePickerAvailability(picker, variants, optionNames, selectedOptions);
      });
    });

    // Dropdown (select) change handlers
    var selects = picker.querySelectorAll('.rq-ws-variant-picker__select');
    selects.forEach(function(sel) {
      sel.addEventListener('change', function() {
        var oi = parseInt(this.getAttribute('data-option-idx'));
        var val = this.value;
        if (!val) {
          delete selectedOptions[oi];
        } else {
          selectedOptions[oi] = val;
          manualSelections[oi] = true;
        }
        checkResolution(true);
        updatePickerAvailability(picker, variants, optionNames, selectedOptions);
      });
    });

    return picker;
  }

  function findMatchingVariant(variants, optionNames, selected) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      var so = v.selectedOptions || [];
      for (var oi = 0; oi < optionNames.length; oi++) {
        var soVal = null;
        for (var j = 0; j < so.length; j++) {
          if (so[j].name === optionNames[oi]) { soVal = so[j].value; break; }
        }
        if (soVal !== selected[oi]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  // For each option group, return a Set of values that lead to at least one valid variant
  // given the current selections in other option groups
  function getAvailableValues(variants, optionNames, currentSelections, targetIdx) {
    var available = {};
    for (var vi = 0; vi < variants.length; vi++) {
      var so = variants[vi].selectedOptions || [];
      var compatible = true;
      for (var k in currentSelections) {
        if (parseInt(k) === targetIdx) continue;
        var soVal = null;
        for (var j = 0; j < so.length; j++) {
          if (so[j].name === optionNames[k]) { soVal = so[j].value; break; }
        }
        if (soVal !== currentSelections[k]) { compatible = false; break; }
      }
      if (compatible) {
        for (var j2 = 0; j2 < so.length; j2++) {
          if (so[j2].name === optionNames[targetIdx]) { available[so[j2].value] = true; break; }
        }
      }
    }
    return available;
  }

  // Update pill/option availability classes in a picker container
  function updatePickerAvailability(container, variants, optionNames, currentSelections) {
    for (var oi = 0; oi < optionNames.length; oi++) {
      var avail = getAvailableValues(variants, optionNames, currentSelections, oi);
      // Pills
      var pills = container.querySelectorAll('[data-option-idx="' + oi + '"].rq-ws-variant-picker__pill');
      for (var pi = 0; pi < pills.length; pi++) {
        var val = pills[pi].getAttribute('data-value');
        if (avail[val]) {
          pills[pi].classList.remove('rq-ws-variant-picker__pill--unavailable');
        } else {
          pills[pi].classList.add('rq-ws-variant-picker__pill--unavailable');
        }
      }
      // Dropdowns
      var sel = container.querySelector('select[data-option-idx="' + oi + '"]');
      if (sel) {
        for (var si = 0; si < sel.options.length; si++) {
          var optEl = sel.options[si];
          if (!optEl.value) continue; // skip placeholder
          optEl.disabled = !avail[optEl.value];
        }
      }
    }
  }

  /* CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — ONE renderer for a group of choices.

     The swatch / dropdown / text-pill cascade was written out four times across this file, and the
     copy that rendered CUSTOM options had none of it — custom options were a bare <select>. That
     was invisible while custom options were rare, and stops being acceptable now that the theme's
     Legend template blocks arrive as custom options: "Metal Shroud Color" is the same 30-colour
     powder-coat chart as "Frame Color" and has to look like it, or the rep is picking a shroud
     colour off a text list beside a wall of swatch circles for the frame.

     `attr` is the data-attribute that binds a pill back to its group — 'data-option-idx' for a
     variant option, 'data-custom-idx' for a custom one — which is the only thing that differed.

     Swatch source order matches the rest of the workstation: the theme's settings.swatch_colors map
     (name-keyed, see UI notes on Legend swatches) first, then Shopify's own option-value swatches. */
  function renderOptionGroup(name, values, selectedValue, attr, idx, apiSwatches, typedValue) {
    var swMap = window.__wsSwatchUrls || {}, swColors = window.__wsSwatchColors || {};
    var apiSw = apiSwatches || {};
    var vals = values || [];
    var html = '<div class="rq-ws-inline-picker__group" ' + attr + '="' + idx + '">';
    html += '<div class="rq-ws-inline-picker__group-label">' + escHtml(name);
    if (selectedValue) html += ' <span style="font-size:11px;opacity:.6;font-weight:400">(' + escHtml(selectedValue) + ')</span>';
    /* The rep typed something into this row that is not one of the choices. Show it rather than
       silently ignoring it (which is what pre-selection did before): the rep needs to see WHY the
       group looks unset, and the value is about to print on a PO if nobody touches it. */
    if (typedValue) html += ' <span class="rq-ws-inline-picker__typed" title="Typed into the quote, but not one of this product’s choices">typed: “' + escHtml(typedValue) + '”</span>';
    html += '</div>';

    var hasSw = vals.some(function(v) { return !!swMap[v] || !!swColors[v] || !!apiSw[v]; });
    function pill(v) {
      var sel = selectedValue === v ? ' rq-ws-variant-picker__pill--selected' : '';
      var base = ' ' + attr + '="' + idx + '" data-value="' + escAttr(v) + '" type="button"';
      var imgSw = swMap[v], colorSw = swColors[v], shopifySw = apiSw[v];
      var swatchCls = 'rq-ws-variant-picker__pill rq-ws-variant-picker__pill--swatch' + sel;
      var dot = 'width:32px;height:32px;border-radius:50%;padding:0;border:2px solid var(--rq-border-light);';
      if (imgSw) return '<button class="' + swatchCls + '"' + base + ' data-label="' + escAttr(v) + '"><img class="rq-ws-variant-picker__swatch-img" src="' + escAttr(imgSw) + '" alt="' + escAttr(v) + '"></button>';
      if (colorSw) return '<button class="' + swatchCls + '"' + base + ' data-label="' + escAttr(v) + '" style="background:' + escAttr(colorSw) + ';' + dot + '"></button>';
      if (shopifySw && shopifySw.color) return '<button class="' + swatchCls + '"' + base + ' data-label="' + escAttr(v) + '" style="background:' + escAttr(shopifySw.color) + ';' + dot + '"></button>';
      if (shopifySw && shopifySw.image) return '<button class="' + swatchCls + '"' + base + ' data-label="' + escAttr(v) + '"><img class="rq-ws-variant-picker__swatch-img" src="' + escAttr(shopifySw.image) + '" alt="' + escAttr(v) + '"></button>';
      return '<button class="rq-ws-variant-picker__pill' + sel + '"' + base + '>' + escHtml(v) + '</button>';
    }

    if (hasSw) {
      html += '<div class="rq-ws-inline-picker__pills rq-ws-inline-picker__pills--swatches">';
      vals.forEach(function(v) { html += pill(v); });
      html += '</div>';
    } else if (vals.length > 8) {
      html += '<select class="rq-ws-variant-picker__select" ' + attr + '="' + idx + '"><option value="">Select ' + escHtml(name) + '...</option>';
      vals.forEach(function(v) { html += '<option value="' + escAttr(v) + '"' + (selectedValue === v ? ' selected' : '') + '>' + escHtml(v) + '</option>'; });
      html += '</select>';
    } else {
      html += '<div class="rq-ws-inline-picker__pills">';
      vals.forEach(function(v) { html += pill(v); });
      html += '</div>';
    }
    return html + '</div>';
  }

  /* CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — hang the picker off the button that opened it.

     Ryan: it should "pop down left aligned with the options button, right below it". The panel is
     position:fixed (see the CSS note — it has to escape .rq-ws-vendor-group's overflow:hidden), so
     the coordinates have to be computed rather than inherited.

     Re-run whenever the panel's own size changes: the loading state is one line tall and the real
     content is several hundred pixels, so a panel that fit below while loading may not fit after. */
  function anchorPickerTo(picker, anchorEl) {
    if (!anchorEl) return;
    var GAP = 6, EDGE = 12;
    var a = anchorEl.getBoundingClientRect();
    var w = picker.offsetWidth, h = picker.offsetHeight;

    // Left-aligned with the button, pulled back only far enough to stay on screen.
    var left = a.left;
    if (left + w > window.innerWidth - EDGE) left = window.innerWidth - EDGE - w;
    if (left < EDGE) left = EDGE;

    /* Below the button by default. Flip above only when below genuinely does not fit AND above has
       more room — otherwise a tall panel near the bottom of a long quote would jump over the button
       and cover the rows the rep was just reading. */
    var below = window.innerHeight - a.bottom - GAP - EDGE;
    var above = a.top - GAP - EDGE;
    var top = a.bottom + GAP;
    if (h > below && above > below) top = Math.max(EDGE, a.top - GAP - h);

    picker.style.left = Math.round(left) + 'px';
    picker.style.top = Math.round(top) + 'px';
  }

  function buildInlineConfigPicker(item, slot, opts) {
    var allOptions = !!(opts && opts.allOptions);
    var picker = document.createElement('div');
    picker.className = 'rq-ws-inline-picker rq-ws-inline-picker--anchored';
    picker.innerHTML = '<div class="rq-ws-inline-picker__status">Loading variant data...</div>';
    slot.appendChild(picker);

    /* The pill lives in the SKU cell; the slot the picker mounts into is in the Item cell. Anchor to
       the pill when there is one, and fall back to the slot so any future launcher still lands
       somewhere sane rather than at 0,0. */
    var anchorEl = dom.itemsContainer.querySelector('.rq-ws-options-pill[data-item-id="' + item.id + '"]') || slot;
    var reposition = function() { anchorPickerTo(picker, anchorEl); };
    reposition();

    /* Self-cleaning listeners: the picker is torn down by four separate paths (Close, TBD, Apply,
       and the toggle in workstation-table.js), and threading a teardown through all four is how one
       of them ends up leaking a scroll handler per open. Checking whether the node is still in the
       document is cheaper than being right about every exit. */
    var track = function() {
      if (!document.body.contains(picker)) {
        window.removeEventListener('scroll', track, true);
        window.removeEventListener('resize', track);
        return;
      }
      reposition();
    };
    window.addEventListener('scroll', track, true);
    window.addEventListener('resize', track);
    Q.fetchProductVariants({ handle: item.productHandle, vendor: item.vendor }).then(function(fp) {
      if (!fp) { picker.innerHTML = '<div class="rq-ws-inline-picker__status" style="color:var(--rq-error)">Failed to load product data</div>'; reposition(); return; }
      var variants = fp.variants || [], allOpts = Q.normalizeOptions(fp.options || []), custOpts = fp.customOptions || item.customOptions || [];
      var selOpts = {}, selCust = {}, optNames = allOpts.map(function(o) { return o.name; });
      /* CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — drop a custom option that duplicates a real
         variant option, ONCE, before anything reads the list.

         The Legend variant collapse moves Frame Color out of the variant matrix and into a theme
         template block, so a product mid-conversion carries the same label on both carriers. The
         worker filters this too, but `item.customOptions` is persisted on the quote and an older
         saved quote can still hold a pre-dedup copy.

         ⚠️ Filtered HERE rather than at the render loop, which is where the first cut put it: the
         pref pre-fill and the Apply handler also walk custOpts, so a skipped-but-present entry
         would still take a preference and still write "Frame Color: …" from the custom side — after
         the variant side had already written the row, silently winning. One list, one answer. */
      if (custOpts.length && optNames.length) {
        custOpts = custOpts.filter(function(co) { return optNames.indexOf(co.label) === -1; });
      }
      /* CUSTOM_SPECMISMATCH_BY_CLAUDE (Ryan 2026-08-21) — WHAT THIS LINE IS CURRENTLY PINNED TO.

         The apply handler below rewrites the colour sub-descriptions unconditionally but only
         reassigns item.variantId `if (v)` — a full variant match. A partial apply therefore left
         the row saying one colour and the draft order saying another, and the draft is what the
         vendor PO prints from. That is RW-1284-A: "Frame Color: Silver Vein Powder Coat" on the
         quote, variant 46900767359212 ("Textured Black Powder Coat / Black Upholstery") on the
         order, and Legend built it black.

         Reading the pinned variant's own option values lets a partial change RESOLVE instead of
         drift — change Frame Color on a configured line and it moves to the sibling variant, which
         is what the rep already believes clicking a swatch does (it is what a PDP does). Matched by
         id with the gid prefix normalized off: /product-by-handle returns full gids, the compact
         catalog strips them, and both shapes reach item.variantId. */
      var _curV = null, curSel = {};
      var _bareId = function (x) { return String(x == null ? '' : x).replace(/^gid:\/\/shopify\/ProductVariant\//, ''); };
      if (item.variantId) {
        var _wantId = _bareId(item.variantId);
        _curV = variants.find(function(vv) { return vv && _bareId(vv.id) === _wantId; }) || null;
      }
      if (_curV) {
        var _curSo = _curV.selectedOptions || [];
        optNames.forEach(function(n, oi) {
          for (var j = 0; j < _curSo.length; j++) { if (_curSo[j].name === n) { curSel[oi] = _curSo[j].value; break; } }
        });
      }
      /* END CUSTOM_SPECMISMATCH_BY_CLAUDE */
      /* CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — read the rep's typed sub-text back into the
         picker, and KEEP what does not parse.

         Two things changed here. First, a value that is not one of the option's choices used to
         fall on the floor: the group simply rendered unset, with no hint that the row said
         "Kickstand for Upright Storage: Maybe" and was about to print that on the PO. It is now
         captured in `typedOpts` / `typedCust` and shown beside the choices.

         Second, CUSTOM options were never validated at all — `selCust[ci] = sdV` accepted anything,
         so junk in a custom row came back as a legitimate-looking selection and Apply wrote it
         straight back out. Same test both sides now.

         Parsed on the FIRST colon rather than on ': ', which is what subDescPrefix and every other
         reader in the workstation use. The old split needed the space, so a row typed
         "Frame Color:Mars Red Powder Coat" was invisible to the picker. */
      var typedOpts = {}, typedCust = {};
      if (item.subDescriptions && item.subDescriptions.length) {
        item.subDescriptions.forEach(function(sd) {
          var colon = String(sd).indexOf(':');
          if (colon === -1) return;
          var sdN = sd.substring(0, colon).trim(), sdV = sd.substring(colon + 1).trim();
          if (!sdN || !sdV) return;
          for (var oi = 0; oi < allOpts.length; oi++) {
            if (allOpts[oi].name !== sdN) continue;
            if (allOpts[oi].values.indexOf(sdV) !== -1) selOpts[oi] = sdV;
            else if (!/^TBD$/i.test(sdV)) typedOpts[oi] = sdV;
            return;
          }
          for (var ci = 0; ci < custOpts.length; ci++) {
            if (custOpts[ci].label !== sdN) continue;
            if ((custOpts[ci].values || []).indexOf(sdV) !== -1) selCust[ci] = sdV;
            else if (!/^TBD$/i.test(sdV)) typedCust[ci] = sdV;
            return;
          }
        });
      }
      var userClickedOpts = {}; // track which options the user explicitly interacted with
      var userClickedCust = {}; // same, for line-item-property options (shroud colour, peg count…)
      // Track which options are explicitly TBD (user set them to TBD) — don't pre-fill from prefs
      var tbdOpts = {}, tbdCust = {};
      if (item.subDescriptions) {
        item.subDescriptions.forEach(function(sd) {
          if (/:\s*TBD\s*$/i.test(sd)) {
            var colon = sd.indexOf(':');
            if (colon > -1) {
              var optName = sd.substring(0, colon).trim();
              for (var oi = 0; oi < allOpts.length; oi++) { if (allOpts[oi].name === optName) { tbdOpts[oi] = true; break; } }
              for (var ci = 0; ci < custOpts.length; ci++) { if (custOpts[ci].label === optName) { tbdCust[ci] = true; break; } }
            }
          }
        });
      }
      allOpts.forEach(function(opt, oi) { if (!selOpts[oi] && !tbdOpts[oi] && !typedOpts[oi]) { var p = Q.getPref(item.vendor, opt.name, opt.values); if (p) selOpts[oi] = p; } });
      /* CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — custom options read the vendor pref too.

         "Metal Shroud Color" and its siblings are grouped with 'frame' in PREF_GROUPS, so this
         resolves an untouched shroud to the frame colour the rep already chose — which is exactly
         what the storefront does (custom-legend-color-mirror.js) and what the PO defaults to
         (legend-build-spec.js). Three surfaces, one answer.

         ⛔ READ ONLY — there is deliberately no matching savePref() in the Apply handler below. A
         two-tone build (black frame, red shroud) would otherwise write "red" into the shared frame
         slot and tint the NEXT Legend line the rep adds. A mirror reads the source; it never
         becomes the source. */
      custOpts.forEach(function(co, ci) {
        if (selCust[ci] || tbdCust[ci] || typedCust[ci]) return;
        var p = Q.getPref(item.vendor, co.label, co.values || []);
        if (p) selCust[ci] = p;
      });
      // Determine which options this item should show in its picker
      // (only options whose subs are visible under THIS item, not shared ones shown on last item)
      // Duplicate items (same productHandle twice in vendor group) always show all options
      var isLastInVendor = true;
      var isDuplicateItem = false;
      if (item.productHandle) {
        for (var di = 0; di < state.items.length; di++) {
          if (state.items[di].id !== item.id && state.items[di].vendor === item.vendor && state.items[di].productHandle === item.productHandle) { isDuplicateItem = true; break; }
        }
      }
      var visibleOptIdxs = {};
      for (var vi = 0; vi < state.items.length; vi++) {
        if (state.items[vi].vendor === item.vendor && state.items[vi].id !== item.id) {
          // Check if any item comes after this one in the group
          var foundSelf = false;
          for (var vj = 0; vj < state.items.length; vj++) {
            if (state.items[vj].id === item.id) foundSelf = true;
            else if (foundSelf && state.items[vj].vendor === item.vendor) { isLastInVendor = false; break; }
          }
          break;
        }
      }
      if (allOptions || isLastInVendor || isDuplicateItem) {
        /* Last item shows all options; duplicate items also show all (they configure independently).
           CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — and so does a picker opened from the
           Options pill, which sits on EVERY row: hiding the shared frame colour on the first of
           three Legend lines would make the button useless exactly where the rep clicked it. */
        allOpts.forEach(function(opt, oi) { visibleOptIdxs[oi] = true; });
      } else {
        // Non-last, non-duplicate item: only show options whose prefix is item-specific
        // Build the same shared prefix map as renderItems, excluding duplicate-handle items
        var pickerPrefixValues = {};
        var pickerPrefixItemCount = {};
        state.items.forEach(function(si) {
          if (si.vendor !== item.vendor || !si.subDescriptions) return;
          // Exclude items with duplicate handles from shared prefix counting
          if (si.productHandle) {
            var siIsDup = false;
            for (var dk = 0; dk < state.items.length; dk++) {
              if (state.items[dk].id !== si.id && state.items[dk].vendor === si.vendor && state.items[dk].productHandle === si.productHandle) { siIsDup = true; break; }
            }
            if (siIsDup) return;
          }
          var seenInItem = {};
          si.subDescriptions.forEach(function(sd) {
            if (!Q.isVendorColorSubDesc(sd)) return;
            var prefix = Q.subDescPrefix(sd);
            if (!pickerPrefixValues[prefix]) pickerPrefixValues[prefix] = {};
            pickerPrefixValues[prefix][sd] = true;
            if (!seenInItem[prefix]) { seenInItem[prefix] = true; pickerPrefixItemCount[prefix] = (pickerPrefixItemCount[prefix] || 0) + 1; }
          });
        });
        allOpts.forEach(function(opt, oi) {
          var prefix = opt.name;
          var isShared = pickerPrefixItemCount[prefix] > 1 && pickerPrefixValues[prefix] && Object.keys(pickerPrefixValues[prefix]).length === 1;
          if (!Q.isVendorColorSubDesc(prefix + ': x') || !isShared) {
            visibleOptIdxs[oi] = true; // item-specific or non-vendor-color option — show it
          }
        });
      }

      var html = '';
      allOpts.forEach(function(opt, oi) {
        if (!visibleOptIdxs[oi]) return; // skip shared options managed by last item's picker
        html += renderOptionGroup(opt.name, opt.values || [], selOpts[oi], 'data-option-idx', oi, opt.swatches, typedOpts[oi]);
      });
      /* CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — custom options render through the SAME
         builder as variant options, so a Legend shroud colour gets the identical swatch circles as
         the frame colour beside it instead of the bare <select> it used to get. Nothing here knows
         or cares that one carrier is a variant option and the other a line-item property. */
      custOpts.forEach(function(co, ci) {
        html += renderOptionGroup(co.label, co.values || [], selCust[ci], 'data-custom-idx', ci, null, typedCust[ci]);
      });
      html += '<div class="rq-ws-inline-picker__actions"><button class="rq-ws-inline-picker__apply" type="button">Apply</button><span class="rq-ws-inline-picker__status"></span><button class="rq-ws-inline-picker__reset-tbd" type="button">TBD</button><button class="rq-ws-inline-picker__close" type="button">Close</button></div>';
      picker.innerHTML = html;
      /* The panel just went from one line of "Loading variant data..." to its full height, so where
         it fits has changed — re-anchor before the rep sees it. */
      reposition();
      var stEl = picker.querySelector('.rq-ws-inline-picker__status');
      function setStatusText(text, color) {
        stEl.style.color = color || '';
        stEl.innerHTML = '<span class="rq-ws-inline-picker__status-inner">' + escHtml(text) + '</span>';
        // Check overflow after render and add scroll animation if needed
        requestAnimationFrame(function() {
          var inner = stEl.querySelector('.rq-ws-inline-picker__status-inner');
          if (inner && inner.scrollWidth > stEl.clientWidth) {
            var overflow = inner.scrollWidth - stEl.clientWidth;
            inner.style.setProperty('--marquee-offset', '-' + overflow + 'px');
            inner.classList.add('rq-ws-inline-picker__status-inner--scroll');
          }
        });
      }
      function upd() {
        var selCount = Object.keys(selOpts).length + Object.keys(selCust).length;
        var allV = Object.keys(selOpts).length === optNames.length, allC = custOpts.length === 0 || Object.keys(selCust).length === custOpts.length;
        var ab = picker.querySelector('.rq-ws-inline-picker__apply');
        if (allV && allC) {
          var m = findMatchingVariant(variants, optNames, selOpts);
          if (m) { setStatusText(m.title + ' — ' + fmt(parseFloat(m.price))); ab.disabled = false; ab._variant = m; ab._mergedPartial = false; }
          else { setStatusText('Variant not available', 'var(--rq-error)'); ab.disabled = true; }
        } else if (selCount > 0) {
          var r = (optNames.length - Object.keys(selOpts).length) + (custOpts.length - Object.keys(selCust).length);
          /* CUSTOM_SPECMISMATCH_BY_CLAUDE (Ryan 2026-08-21) — a partial apply must not leave the
             variant contradicting a colour row it is about to write.

             Fill the un-chosen VARIANT options from the pinned variant's own values and try to
             resolve. Unresolved custom options are irrelevant here — they are line-item properties,
             not part of the variant — so they must not block the move. */
          var _merged = null;
          if (_curV) {
            var _mSel = {}, _complete = true;
            optNames.forEach(function(n, oi) {
              var val = (selOpts[oi] !== undefined) ? selOpts[oi] : curSel[oi];
              if (val === undefined) _complete = false; else _mSel[oi] = val;
            });
            if (_complete) _merged = findMatchingVariant(variants, optNames, _mSel);
          }
          var _clickedVariantOpt = Object.keys(userClickedOpts).length > 0;
          if (_curV && _clickedVariantOpt && !_merged) {
            /* The rep changed a colour, this line is already pinned to a real variant, and no
               variant carries the combination. Applying would write the new colour into the quote
               while the order — and therefore the PO — kept the old one, silently. Refuse instead:
               a blocked click the rep can see beats a spec the factory reads and we don't. */
            setStatusText('That combination has no variant — the order stays "' + (_curV.title || 'as built') + '"', 'var(--rq-error)');
            ab.disabled = true; ab._variant = null;
          } else {
            setStatusText(r + ' option' + (r !== 1 ? 's' : '') + ' remaining');
            // _merged is null on a line nothing is pinned to yet (a TBD add) — there is no variant
            // to contradict, so the original partial-apply behaviour stands.
            ab.disabled = false; ab._variant = _merged; ab._mergedPartial = !!_merged;
          }
          /* END CUSTOM_SPECMISMATCH_BY_CLAUDE */
        } else { setStatusText('Select an option'); ab.disabled = true; }
      }
      upd();
      updatePickerAvailability(picker, variants, optNames, selOpts);
      /* CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — pills are now emitted for BOTH carriers, so
         the click handler has to ask which one it is before writing.

         ⛔ The previous selector matched every .rq-ws-variant-picker__pill and read data-option-idx
         off it unconditionally. Now that custom options render as pills too, that would have
         evaluated parseInt(null) on every shroud-colour click and written selOpts[NaN] — a variant
         selection that can never match, silently disabling Apply on exactly the products this
         feature was built for. */
      picker.querySelectorAll('.rq-ws-variant-picker__pill[data-option-idx]').forEach(function(pill) {
        pill.addEventListener('click', function() {
          var oi = parseInt(this.getAttribute('data-option-idx')), v = this.getAttribute('data-value');
          picker.querySelectorAll('[data-option-idx="' + oi + '"].rq-ws-variant-picker__pill').forEach(function(s) { s.classList.remove('rq-ws-variant-picker__pill--selected'); });
          this.classList.add('rq-ws-variant-picker__pill--selected'); selOpts[oi] = v; userClickedOpts[oi] = true; upd();
          updatePickerAvailability(picker, variants, optNames, selOpts);
        });
      });
      /* A custom option is a line-item property, not part of the variant — so it never touches
         selOpts and never re-runs variant availability. Clicking one only decides what the build
         spec says. */
      picker.querySelectorAll('.rq-ws-variant-picker__pill[data-custom-idx]').forEach(function(pill) {
        pill.addEventListener('click', function() {
          var ci = parseInt(this.getAttribute('data-custom-idx')), v = this.getAttribute('data-value');
          picker.querySelectorAll('[data-custom-idx="' + ci + '"].rq-ws-variant-picker__pill').forEach(function(s) { s.classList.remove('rq-ws-variant-picker__pill--selected'); });
          this.classList.add('rq-ws-variant-picker__pill--selected'); selCust[ci] = v; userClickedCust[ci] = true; upd();
        });
      });
      picker.querySelectorAll('select[data-option-idx]').forEach(function(s) { s.addEventListener('change', function() { var oi = parseInt(this.getAttribute('data-option-idx')); if (this.value) { selOpts[oi] = this.value; userClickedOpts[oi] = true; } else delete selOpts[oi]; upd(); updatePickerAvailability(picker, variants, optNames, selOpts); }); });
      picker.querySelectorAll('select[data-custom-idx]').forEach(function(s) { s.addEventListener('change', function() { var ci = parseInt(this.getAttribute('data-custom-idx')); if (this.value) { selCust[ci] = this.value; userClickedCust[ci] = true; } else delete selCust[ci]; upd(); }); });
      picker.querySelector('.rq-ws-inline-picker__close').addEventListener('click', function() {
        picker.remove();
        if (Q.searchBackdrop) Q.searchBackdrop.classList.remove('rq-ws-search-backdrop--open');
        dom.itemsContainer.querySelectorAll('.rq-ws-vendor-group').forEach(function(g) { g.style.zIndex = ''; g.style.position = ''; });
      });
      picker.querySelector('.rq-ws-inline-picker__reset-tbd').addEventListener('click', function() {
        // Replace all variant option subs with "OptionName: TBD"
        var existingSubs = (item.subDescriptions || []).slice();
        var subMap = {};
        existingSubs.forEach(function(sd, si) {
          var colon = sd.indexOf(':');
          if (colon !== -1) subMap[sd.substring(0, colon).trim()] = si;
        });
        allOpts.forEach(function(opt, oi) {
          if (!visibleOptIdxs[oi]) return; // only reset visible options
          var entry = opt.name + ': TBD';
          if (subMap[opt.name] !== undefined) { existingSubs[subMap[opt.name]] = entry; }
          else { existingSubs.push(entry); }
        });
        custOpts.forEach(function(co) {
          var entry = co.label + ': TBD';
          if (subMap[co.label] !== undefined) { existingSubs[subMap[co.label]] = entry; }
          else { existingSubs.push(entry); }
        });
        item.subDescriptions = existingSubs;
        // Only propagate TBD to other items for SHARED subs (prefixes that other items already have).
        // Item-specific subs (only this item has the prefix) stay local.
        // Duplicate items (same productHandle twice) never propagate — they configure independently.
        if (!isDuplicateItem) {
          state.items.forEach(function(other) {
            if (other.id === item.id || other.vendor !== item.vendor) return;
            if (!other.subDescriptions || !other.subDescriptions.length) return;
            var otherMap = {};
            other.subDescriptions.forEach(function(sd, si) {
              var colon = sd.indexOf(':');
              if (colon !== -1) otherMap[sd.substring(0, colon).trim()] = si;
            });
            allOpts.forEach(function(opt) {
              if (!Q.isVendorColorSubDesc(opt.name + ': x')) return;
              // Only update if the other item already has this prefix (shared sub)
              if (otherMap[opt.name] !== undefined) {
                other.subDescriptions[otherMap[opt.name]] = opt.name + ': TBD';
              }
            });
          });
        }
        state.dirty = true;
        picker.remove();
        if (Q.searchBackdrop) Q.searchBackdrop.classList.remove('rq-ws-search-backdrop--open');
        dom.itemsContainer.querySelectorAll('.rq-ws-vendor-group').forEach(function(g) { g.style.zIndex = ''; g.style.position = ''; });
        Q.renderItems();
      });
      picker.querySelector('.rq-ws-inline-picker__apply').addEventListener('click', function() {
        if (this.disabled) return;
        var v = this._variant; // null for partial apply

        // Save prefs only for options the user explicitly clicked
        allOpts.forEach(function(opt, oi) { if (selOpts[oi] && userClickedOpts[oi]) Q.savePref(item.vendor, opt.name, opt.values, selOpts[oi]); });

        // Build updated sub-descriptions: update existing subs, only add NEW subs for user-clicked options
        var existingSubs = (item.subDescriptions || []).slice();
        // Map of optName → index in existingSubs
        var subMap = {};
        existingSubs.forEach(function(sd, si) {
          var colon = sd.indexOf(':');
          if (colon !== -1) subMap[sd.substring(0, colon).trim()] = si;
        });
        // Update selected variant options — only touch visible options (skip hidden shared ones on non-last items)
        allOpts.forEach(function(opt, oi) {
          if (selOpts[oi] === undefined) return;
          if (!visibleOptIdxs[oi] && !userClickedOpts[oi]) return; // skip hidden options unless explicitly clicked
          var entry = opt.name + ': ' + selOpts[oi];
          if (subMap[opt.name] !== undefined) { existingSubs[subMap[opt.name]] = entry; }
          else if (userClickedOpts[oi]) { existingSubs.push(entry); } // only add new subs if user explicitly selected
        });
        /* Update selected custom options.

           CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — a row the rep TYPED is only overwritten if
           the rep clicked that group. Junk ("Kickstand for Upright Storage: Maybe") never reached
           selCust, so it survives Apply untouched unless someone actually picks a value — the same
           rule the variant-option loop directly above follows, now applied to both carriers.

           ⛔ NO savePref() here, deliberately. See the read-only note where custom options pick up
           the vendor pref: a mirrored surface reads the frame colour, it must never become it. */
        custOpts.forEach(function(co, ci) {
          if (selCust[ci] === undefined) return;   // typed junk lands in typedCust, never here
          var entry = co.label + ': ' + selCust[ci];
          if (subMap[co.label] !== undefined) { existingSubs[subMap[co.label]] = entry; }
          else { existingSubs.push(entry); }
        });
        item.subDescriptions = existingSubs;

        // Propagate user-clicked shared options to other items in the vendor group
        // (mirrors Reset to TBD logic: only update items that already have the prefix)
        // Duplicate items (same productHandle twice) never propagate — they configure independently.
        if (!isDuplicateItem) {
          allOpts.forEach(function(opt, oi) {
            if (!userClickedOpts[oi] || !selOpts[oi]) return;
            if (!Q.isVendorColorSubDesc(opt.name + ': x')) return;
            var entry = opt.name + ': ' + selOpts[oi];
            state.items.forEach(function(other) {
              if (other.id === item.id || other.vendor !== item.vendor) return;
              if (!other.subDescriptions || !other.subDescriptions.length) return;
              for (var si = 0; si < other.subDescriptions.length; si++) {
                var colon = other.subDescriptions[si].indexOf(':');
                if (colon !== -1 && other.subDescriptions[si].substring(0, colon).trim() === opt.name) {
                  other.subDescriptions[si] = entry;
                  break;
                }
              }
            });
          });
        }

        // Full variant match — update SKU, cost, price
        if (v && !this._mergedPartial) {
          /* CUSTOM_SPECMISMATCH_BY_CLAUDE (Ryan 2026-08-22) — DON'T REPRICE A LINE SOMEONE IS
             RE-CONFIGURING.

             This branch used to end with `points = autoPoints(cost, MAP); directPrice = MAP`, which
             is right on the ADD path (doPickerAdd, where there is no rep pricing yet) but wrong
             here: this picker re-opens a line that already exists. Correcting a colour therefore
             snapped the quote back to list price and threw away the rep's margin, silently.

             It is not hypothetical — it is the blast radius of fixing RW-1284-A. That line carries
             25 points ($2,990 cost -> $3,986.67) against a $4,449 MAP on a deal already SOLD
             against customer PO #P0011115. Re-picking the frame colour to correct the build spec
             would have moved the line to $4,449 with nothing said, on an order the customer has
             already committed to in writing.

             So the rep's MARGIN is what is held constant, not the price — points is the pricing
             engine's input and price its output (Q.calculateDirect), so a variant whose cost really
             does differ still reprices correctly, just at the margin the rep chose. Falls back to
             the old MAP behaviour when there is no usable prior margin (a line added before pricing
             was set, or with a zero cost), so nothing that worked stops working. */
          var _priorPoints = parseFloat(item.points);
          var _keepMargin = isFinite(_priorPoints) && _priorPoints !== 0 && parseFloat(item.directPrice) > 0;
          var _carried = carriedCost(item, variants, v);   // CUSTOM_ECORE2027_BY_CLAUDE — read BEFORE variantId moves
          item.variantId = v.id; item.configured = true; item.sku = v.sku || item.sku;
          item.cost = _carried; item.msrp = parseFloat(v.compareAtPrice) || item.msrp;
          item.mapPrice = parseFloat(v.price) || item.mapPrice;
          item.pendingOptions = null; item.customOptions = null;
          if (_keepMargin && item.cost > 0) {
            item.points = _priorPoints;
            item.directPrice = Q.calculateDirect(item.cost, _priorPoints);
          } else if (item.cost > 0 && item.mapPrice > 0) {
            item.points = autoPoints(item.cost, item.mapPrice); item.directPrice = item.mapPrice;
          }
        } else if (v) {
          /* CUSTOM_SPECMISMATCH_BY_CLAUDE (Ryan 2026-08-21) — MERGED partial apply: the rep changed
             a colour on a line that still has options outstanding, and upd() resolved the sibling
             variant from the pinned one. Move the IDENTITY only.

             Pricing is deliberately NOT snapped back to MAP here. The full-match branch above resets
             directPrice from the variant when there is no prior margin, which is right when the rep
             is choosing the product; here they are correcting one option on a line that may already
             carry a negotiated price. `configured` is untouched too: options are still outstanding.

             ⛔ CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — BUT THE COST/MAP MUST STILL MOVE.

             This branch used to leave every money field alone on the stated grounds that "Legend
             prices every colour the same, so there is nothing to re-read". That is true of a colour
             and FALSE of the option list as a whole: the 3103-L's third option is
             "Kickstand for Upright Storage" = Exclude / Include (+$59.00), one SKU (3103-L) across
             all 1,440 variants but two prices, $839 and $898. So a rep who set the kickstand while
             Pad Color was still TBD took the merged path, moved the line onto the $898 variant, and
             the quote kept selling it at $839 — we would have ordered a part from Legend and given
             it away, silently, on every partially-configured bench.

             Re-read cost and MAP like the full-match branch, and hold the rep's MARGIN exactly the
             same way (points in, price out) so a negotiated line still cannot be snapped to list.
             When the two variants really do cost the same — every Legend colour — every one of
             these assignments is a no-op, which is why this is safe to do unconditionally. */
          var _pPoints = parseFloat(item.points);
          var _pKeepMargin = isFinite(_pPoints) && _pPoints !== 0 && parseFloat(item.directPrice) > 0;
          var _pCarried = carriedCost(item, variants, v);   // CUSTOM_ECORE2027_BY_CLAUDE — read BEFORE variantId moves
          item.variantId = v.id; item.sku = v.sku || item.sku;
          if (_pCarried > 0) item.cost = _pCarried;
          if (parseFloat(v.compareAtPrice) > 0) item.msrp = parseFloat(v.compareAtPrice);
          if (parseFloat(v.price) > 0) item.mapPrice = parseFloat(v.price);
          if (_pKeepMargin && item.cost > 0) item.directPrice = Q.calculateDirect(item.cost, _pPoints);
        }

        picker.remove();
        if (Q.searchBackdrop) Q.searchBackdrop.classList.remove('rq-ws-search-backdrop--open');
        dom.itemsContainer.querySelectorAll('.rq-ws-vendor-group').forEach(function(g) { g.style.zIndex = ''; g.style.position = ''; });
        state.dirty = true;
        Q.renderItems();
      });
      upd();
      // Note: picker auto-apply removed — was causing shared sub desync when prefs
      // resolved the last item but siblings stayed at TBD. autoConfigureByPreferences()
      // handles TBD resolution when items are first added; the picker should always
      // let the user see options and make their own choices.
    }).catch(function() { picker.innerHTML = '<div class="rq-ws-inline-picker__status" style="color:var(--rq-error)">Failed to load product data</div>'; reposition(); });
  }

  /* CUSTOM_ECORE2027_BY_CLAUDE (Ryan 2026-10-02, RW-1443-A) — A LINE THAT MOVES TO A SIBLING VARIANT
     KEEPS ITS OWN COST and takes only the catalog DIFFERENCE between the two variants.

     Both re-configure branches below used to overwrite the line's cost with the new variant's
     CATALOG cost. That is the same number when nothing has changed, and the wrong one the day a
     price list rolls over: an Ecore line quoted at the 2026 cost ($12.37 a plank) and switched from
     Rockport to Elk Ridge after the 2027 push came back at $12.99. The rep held the customer's
     price, the PO read the stored cost, and we would have paid Ecore the 2027 price on a deal Ecore
     honours at 2026. Every Heritage Motivate colour costs the same, so the right answer was the
     line's own $12.37.

     The DELTA, not "never move the cost": the 3103-L kickstand is one SKU across two prices ($839 /
     $898, see the merged branch), and that +$59 must still arrive. new = line cost + (new catalog
     cost - old catalog cost) gives both: same-cost colours keep the locked cost exactly, a real
     step moves it by the step. Falls back to the new variant's catalog cost (the old behaviour)
     whenever the delta cannot be read honestly: no stored cost, the old variant not in this
     product's list, either catalog cost missing, or a line toggled to per-sq-ft (its stored cost
     is per sq ft and the catalog's is per piece). */
  function carriedCost(item, variants, v) {
    var newC = parseFloat(v && v.cost) || 0;
    var cur = parseFloat(item.cost) || 0;
    if (!(cur > 0) || !(newC > 0) || (item.unitMode && item.unitMode !== 'piece')) return newC;
    var bare = function(id) { return String(id || '').replace('gid://shopify/ProductVariant/', ''); };
    var oldId = bare(item.variantId);
    if (!oldId) return newC;
    if (oldId === bare(v.id)) return cur;
    var old = (variants || []).find(function(x) { return bare(x.id) === oldId; });
    var oldC = old ? (parseFloat(old.cost) || 0) : 0;
    if (!(oldC > 0)) return newC;
    var out = Math.round((cur + newC - oldC) * 100) / 100;
    return out > 0 ? out : newC;
  }

  function autoConfigureByPreferences() {
    var changed = false;

    // 1. Resolve TBD and sync stale pref values on items with productHandle
    state.items.forEach(function(item) {
      if (!item.productHandle || !item.subDescriptions || !item.subDescriptions.length) return;

      var newSubs = [];
      var anyChange = false;
      item.subDescriptions.forEach(function(sd) {
        var colon = sd.indexOf(':');
        if (colon === -1) { newSubs.push(sd); return; }
        var optName = sd.substring(0, colon).trim();
        var optVal = sd.substring(colon + 1).trim();

        // Check if this option name has a saved pref
        var pref = null;
        var cat = Q.catalog ? Q.catalog.find(function(cp) { return cp.h === item.productHandle; }) : null;
        if (cat && cat.o) {
          for (var ci = 0; ci < cat.o.length; ci++) {
            if (cat.o[ci].n === optName) {
              pref = Q.getPref(item.vendor, optName, cat.o[ci].v);
              break;
            }
          }
        }
        if (!pref) {
          var group = Q.getPrefGroup(optName);
          if (group !== optName) {
            var fallbackPref = Q.vendorPrefs[item.vendor + '|' + group] || null;
            // Validate fallback pref against this product's actual option values
            if (fallbackPref && cat && cat.o) {
              for (var fi = 0; fi < cat.o.length; fi++) {
                if (cat.o[fi].n === optName && cat.o[fi].v.indexOf(fallbackPref) !== -1) { pref = fallbackPref; break; }
              }
            }
          }
        }

        if (pref && optVal === 'TBD') {
          // Pref exists and value is TBD — resolve it (but don't overwrite user-configured values)
          newSubs.push(optName + ': ' + pref);
          anyChange = true;
        } else if (!pref && optVal === 'TBD') {
          // Still TBD, no pref available — keep as-is
          newSubs.push(sd);
        } else {
          newSubs.push(sd);
        }
      });

      if (anyChange) {
        item.subDescriptions = newSubs;
        changed = true;
      }
    });

    // 2. Resolve unconfigured items (original logic — for items added with configured: false)
    var unc = state.items.filter(function(i) { return !i.configured && i.productHandle; });
    unc.forEach(function(item) {
      var cached = Q.variantCache[item.productHandle];
      if (!cached) return;
      var ao = Q.normalizeOptions(cached.options || []), on = ao.map(function(o) { return o.name; }), ro = {}, ok = true;
      ao.forEach(function(opt, oi) { var p = Q.getPref(item.vendor, opt.name, opt.values); if (p) ro[oi] = p; else ok = false; });
      var co = cached.customOptions || item.customOptions || [];
      if (co.length > 0 || !ok) return;
      var m = findMatchingVariant(cached.variants || [], on, ro);
      if (!m) return;
      var sd = []; ao.forEach(function(opt, oi) { if (ro[oi]) sd.push(opt.name + ': ' + ro[oi]); });
      item.variantId = m.id; item.configured = true; item.sku = m.sku || item.sku;
      item.cost = parseFloat(m.cost) || 0; item.msrp = parseFloat(m.compareAtPrice) || item.msrp;
      item.mapPrice = parseFloat(m.price) || item.mapPrice; item.subDescriptions = sd;
      item.pendingOptions = null; item.customOptions = null;
      if (item.cost > 0 && item.mapPrice > 0) { item.points = autoPoints(item.cost, item.mapPrice); item.directPrice = item.mapPrice; }
      changed = true;
    });

    if (changed) Q.renderItems();
  }

  // Exports
  Q.buildVariantPicker = buildVariantPicker;
  Q.findMatchingVariant = findMatchingVariant;
  Q.getAvailableValues = getAvailableValues;
  Q.updatePickerAvailability = updatePickerAvailability;
  Q.renderOptionGroup = renderOptionGroup;
  Q.anchorPickerTo = anchorPickerTo;
  Q.buildInlineConfigPicker = buildInlineConfigPicker;
  Q.autoConfigureByPreferences = autoConfigureByPreferences;
})();
